import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';
import RendersIcons from './RendersIcons';

// Costanti Colori
const VESPER_GOLD = "#C5A039";
const VESPER_GREEN = "#1B3030";

// 1. Icona Cocktail SVG (Replicata dinamicamente)
const VesperMartiniIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        {/* Disegno semplificato del bicchiere Martini con oliva */}
        <path
            d="M12,21L12,13.8L5,6.8V5H19V6.8L12,13.8L12,21ZM12,11.8L17,6.8V6H7V6.8L12,11.8ZM13.5,8C13.5,8.8 12.8,9.5 12,9.5C11.2,9.5 10.5,8.8 10.5,8C10.5,7.2 11.2,6.5 12,6.5C12.8,6.5 13.5,7.2 13.5,8Z"
            fill={VESPER_GOLD} // Applichiamo l'oro Vesper
        />
    </SvgIcon>
);

const VesperLogoText = () => {
    return (
        // Contenitore Principale
        <Box
            sx={{
                backgroundColor: VESPER_GREEN,
                padding: { xs: '30px', md: '50px' },
                display: 'flex',
                flexDirection: 'column', // Disposizione verticale
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100px', // Altezza minima per visibilità
                borderRadius: '8px', // Opzionale
            }}
        >
            {/* 2. L'Icona in alto */}
            <RendersIcons title={"SPRITZ"} />

            {/* 3. Titolo Principale: VESPER CAFFÈ */}
            <Typography
                variant="h1" // Semantica principale
                component="div"
                sx={{
                    color: VESPER_GOLD, // Oro Vesper

                    // --- STILE FONT Art Déco ---
                    fontFamily: '"Playfair Display", "Georgia", serif',
                    fontWeight: 600,
                    textTransform: 'uppercase', // Tutto maiuscolo

                    // --- SPAZIATURA E DIMENSIONI ---
                    fontSize: {
                        xs: '1.2rem', // Più piccolo su mobile
                        sm: '2.2rem',
                        md: '2.8rem'    // Grande su desktop
                    },
                    letterSpacing: '0.18em', // Spaziatura larga cruciale per eleganza
                    lineHeight: 1.1,
                    marginBottom: '5px', // Spazio sotto il titolo
                    marginTop:'25px',
                    textShadow: '2px 2px 10px rgba(0,0,0,0.7)',
                }}
            >
                Vesper Caffè
            </Typography>

            {/* 5. Tagline: Shaken, not stirred */}
            <Typography
                variant="body1"
                component="div"
                sx={{
                    color: VESPER_GOLD,
                    // Font Serif standard per il corpo
                    fontFamily: '"Georgia", "Times New Roman", serif',
                    fontStyle: 'italic', // Corsivo come nel logo
                    fontWeight: 400,

                    fontSize: {
                        xs: '0.9rem',
                        sm: '1rem',
                    },
                    letterSpacing: '0.05em', // Spaziatura standard
                    lineHeight: 1,
                    opacity: 0.85, // Più tenue per gerarchia visiva
                }}
            >
                Shaken, not stirred
            </Typography>
        </Box>
    );
};

export default VesperLogoText;